import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Box, Divider } from "@mui/material";
import { filterPage } from "components/common/Filters/FiltersHelper";
import { setPageFilter } from "components/common/Filters/GlobalFilters.slice";
import KebabMenu from "components/common/KebabMenu";
import Typography from "components/common/Typography";
import { uniqueId } from "lodash";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { resetSorting } from "redux/sorting.slice";
import { checkWithLowerCase } from "utils/CommonChecker";
import { minSearchStrLength } from "utils/CommonConstants";
import { setCorpSearchText, setCorpViewSelectedTab, setSelectedList, setSelectedListCategory } from "../CorpUser.Slice";

interface Props {
  item: any;
  setOpen: (val: boolean) => void;
  searchedText: string;
  keyId: string;
}
const AccordionData = (props: Props) => {
  const { item, setOpen, searchedText, keyId } = props;
  const listCategory = useAppSelector((state) => state.CorpDashboard.myListsSelected.listCategory);
  const selectedList = useAppSelector((state) => state.CorpDashboard.myListsSelected.selectedList);
  const dispatch = useAppDispatch();

  const excludedPinAndUnPin = (item: any, isFlagged: string) => {
    return item?.listType !== "bookmarked"
      ? item?.menu?.filter((m: any) =>
          checkWithLowerCase(isFlagged ?? "", "Y") ? m.label !== "Pin to top" : m.label !== "Unpin from top"
        )
      : item?.menu;
  };

  return (
    <Accordion
      className="my-list-corp-accordian-main"
      defaultExpanded={searchedText?.length > minSearchStrLength || listCategory === item.listType}
      key={uniqueId(keyId)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className="my-list-corp-accordian-summary">
        <Typography variant="body2"> {item.label}</Typography>
      </AccordionSummary>
      <AccordionDetails className="my-list-corp-accordian-detail">
        <Divider></Divider>
        {item?.data?.map((el: any, index: number) => {
          return (
            <Box
              key={uniqueId(el?.id)}
              className={`my-list-corp-data ${
                item?.listType === listCategory && el?.name === selectedList?.name ? "selected-list" : ""
              }`}
              onClick={() => {
                dispatch(
                  setPageFilter({
                    pageName:
                      item?.listType === "consultant" ? filterPage.consultantListDisplay : filterPage.listDisplay,
                    defaultFilter: el?.filters || [],
                    modifiedFilter: []
                  })
                );
                dispatch(setSelectedList(el));
                dispatch(setSelectedListCategory(item.listType));

                dispatch(
                  resetSorting({
                    tableName: "plansSort_myList"
                  })
                );
                dispatch(
                  resetSorting({
                    tableName: "propertiesSort_myList"
                  })
                );
                dispatch(setCorpSearchText({ view: "myList", value: "" }));

                if (item.listType === "bookmarked") dispatch(setCorpViewSelectedTab({ type: "myList", val: index }));
                else dispatch(setCorpViewSelectedTab({ type: "myList", val: 0 }));
                setOpen(false);
              }}
            >
              <Typography variant="body2" showBold className="ellipse-two ">
                {el?.name || ""}
              </Typography>
              <div className={item?.listType !== "bookmarked" ? "list-pin-menu" : "d-none"}>
                <Box className={checkWithLowerCase(el?.isFlagged ?? "", "Y") ? "list-pinned" : "list-unpinned"}></Box>
              </div>
              <KebabMenu options={excludedPinAndUnPin(item, el?.isFlagged)} value={el} />
            </Box>
          );
        })}
      </AccordionDetails>
    </Accordion>
  );
};
export default AccordionData;
